import { Formik, Form } from "formik";

import { Col, Container, Row } from "reactstrap";

import FormHelpers from "../../helpers/FormHelpers";

function AddToCartForm(props) {
  const addOrUpdate = props.donation.CartItemId ? "updated in" : "added to";

  return (
    <div className="cfg-input-form cfg-addtocart" data-step="addtocart">
      <Formik>
        {({ values, errors, touched }) => (
          <Form className="text-start">
            <Container className="cfg-form-section">
              <Row className="text-center">
                <Col xs="12">
                  <div className="alert alert-primary" role="alert">
                    Your request has been {addOrUpdate} your cart!
                    <span>
                      <br />
                      To make changes in your cart,{" "}
                      <a href="/cart">click here</a>.
                    </span>
                  </div>
                </Col>
              </Row>
            </Container>
            <a href="/" className="btn btn-secondary btn-sm">
              Make a New Request
            </a>{" "}
            <a href="/cart" className="btn btn-primary btn-sm float-end">
              View Cart
            </a>
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default AddToCartForm;
